// eslint-disable-next-line node/no-extraneous-import
import FocusTrap from 'focus-trap-react';
import {Component} from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import Button from 'ui/Button';
import Image from 'ui/Image';

class WeighIn extends Component {
    static propTypes = {
        onClose: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
    };

    _onClose = ({target}) => {
        if (['Modal-wrapper', 'Modal-close'].includes(target.className)) {
            this.props.onClose();
        }
    };

    render() {
        const {t, onClose} = this.props;

        return (
            <div className="Modal">
                <div className="Modal-shim" />
                <FocusTrap>
                    <div
                        id="modal_main"
                        className="Modal-wrapper"
                        tabIndex={-1}
                        onClick={this._onClose}
                        onKeyPress={this._onClose}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="modal_title"
                        aria-describedby="modal_desc"
                        aria-live="polite"
                    >
                        <div className="Modal-content">
                            <Image
                                height="90px"
                                src="../img/weigh-in-unlock.png"
                                alt=""
                            />
                            <h2 id="modal_title">{t('weight-check.title')}</h2>
                            <p id="modal_desc">
                                {t('weight-check.description')}
                            </p>
                            <Button
                                color="primary"
                                className="Modal-button"
                                onClick={onClose}
                                autoFocus
                            >
                                {t('ok')}
                            </Button>
                        </div>
                    </div>
                </FocusTrap>
            </div>
        );
    }
}

export default withTranslation()(WeighIn);
